import {getMethod} from '~/api'

async function get(request) {
    return await getMethod('/api/additionalFlightOptions', request)
}

export {get}
